export default __webpack_public_path__ + "static/media/hero-max.5687b4ed.jpg";